module.exports = __webpack_public_path__ + "img/horizontal_7_6_7005.e1d1c96e.png";